module.exports = __webpack_public_path__ + "img/ic_cast-inactive.55fe4e24.svg";